module.exports = __webpack_public_path__ + "img/01.ad98ea66.png";